import { getAuth } from '@/api/ApiCalls';

interface TaxApprovalDocumentResponse {
  name: string;
  description: string;
  uri: string;
  creationTime: string;
}

/**
 * Fetches the tax-approval document URL for a supplier and opens it in a new tab.
 * Returns `null` on success or a human-readable error code/message on failure.
 *
 * Shared by the suppliers-management table, the tax-withholding edit dialog, and
 * the support-request management blade so all three open the document the same way.
 */
export async function openSupplierTaxApprovalDocument(
  supplierId: number,
  token: string | undefined,
): Promise<string | null> {
  try {
    const headers = { Authorization: `Bearer ${token ?? ''}` };
    const doc = await getAuth<TaxApprovalDocumentResponse>(
      `management/suppliers/${supplierId}/tax-approval-document`,
      headers,
    );
    if (doc?.uri) {
      window.open(doc.uri, '_blank', 'noopener,noreferrer');
      return null;
    }
    return 'no_uri';
  } catch (err: unknown) {
    return err instanceof Error ? err.message : 'unknown';
  }
}
